import { devtools, persist } from 'zustand/middleware';

import { type Team } from '@app/client';
import { create } from '@app/store/zustand/helpers/create';

type ReferralData = {
    referralCode?: string;
    inviteCode?: string;
    inviteTeam?: Team;
};
interface ReferralState extends ReferralData {
    setReferralcode: (code?: string) => void;
    setInviteTeam: (Team?: Team) => void;
    setInviteCode: (code?: string) => void;
    clearCode: () => void;
}

const initialState: ReferralData = {
    referralCode: undefined,
    inviteTeam: undefined,
    inviteCode: '',
};

export const useFantasyReferralStore = create<ReferralState>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                setReferralcode: (referralCode) => set({ referralCode }),
                setInviteCode: (inviteCode) => set({ inviteCode }),
                setInviteTeam: (inviteTeam) => set({ inviteTeam }),
                clearCode: () => set(initialState),
            }),
            { name: 'fantasy-referral-store' },
        ),
    ),
);
